module.exports = __webpack_public_path__ + "static/img/icon_gps.3813235a.png";